"use strict";
/*export enum EPageSizeRange {
  smallMobile = "smallMobile",
  mobile = "mobile",
  tablet = "tablet",
  desktop = "desktop",
  bigDesktop = "bigDesktop",
}*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetectDeviceUtils = exports.EUDI = exports.CMaxWidthForPageSizeRange = exports.EPageSizeRange = void 0;
var EPageSizeRange;
(function (EPageSizeRange) {
    EPageSizeRange[EPageSizeRange["smallMobile"] = 0] = "smallMobile";
    EPageSizeRange[EPageSizeRange["mobile"] = 1] = "mobile";
    EPageSizeRange[EPageSizeRange["tablet"] = 2] = "tablet";
    EPageSizeRange[EPageSizeRange["desktop"] = 3] = "desktop";
    EPageSizeRange[EPageSizeRange["bigDesktop"] = 4] = "bigDesktop";
})(EPageSizeRange || (exports.EPageSizeRange = EPageSizeRange = {}));
/*export const CValueForPageSizeRange: TObjectKeyEnumSet<EPageSizeRange, number> = {
  [EPageSizeRange.smallMobile]: 0,
  [EPageSizeRange.mobile]: 1,
  [EPageSizeRange.tablet]: 2,
  [EPageSizeRange.desktop]: 3,
  [EPageSizeRange.bigDesktop]: 4,
};*/
/*export const CMaxWidthForPageSizeRange: TObjectKeyEnumSet<EPageSizeRange, number> = {
  [EPageSizeRange.smallMobile]: 290,
  [EPageSizeRange.mobile]: 585,
  [EPageSizeRange.tablet]: 1023,
  [EPageSizeRange.desktop]: 2000,
  [EPageSizeRange.bigDesktop]: 200000,
};*/
exports.CMaxWidthForPageSizeRange = {
    [EPageSizeRange.smallMobile]: 290,
    [EPageSizeRange.mobile]: 585,
    [EPageSizeRange.tablet]: 1023,
    [EPageSizeRange.desktop]: 2000,
    [EPageSizeRange.bigDesktop]: 200000,
};
/*interface IPageSizeArrayItem {
  size: EPageSizeRange;
  maxWidth: number;
}

const pageSizeRangeArray: IPageSizeArrayItem[] = Object.keys(CMaxWidthForPageSizeRange)
  .map(
    (k): IPageSizeArrayItem => ({
      size: Number(k) as EPageSizeRange,
      maxWidth: CMaxWidthForPageSizeRange[k],
    }),
  )
  .sort((a, b) => a.maxWidth - b.maxWidth);

*/
/*export function pageSizeValue(size: EPageSizeRange): number {
  return CValueForPageSizeRange[size];
}*/
var EUDI;
(function (EUDI) {
    EUDI["MOUSE"] = "MOUSE";
    EUDI["TOUCH"] = "TOUCH";
})(EUDI || (exports.EUDI = EUDI = {}));
function initializeAndDetectUserDeviceInterface(detected) {
    function onMouseMove() {
        console.log(`Detected MOUSE!`);
        window.removeEventListener("mousemove", onMouseMove);
        detected(EUDI.MOUSE);
    }
    function onTouchStart(e) {
        console.log(`Detected TOUCH!`);
        window.removeEventListener("mousemove", onMouseMove);
        window.removeEventListener("touchstart", onTouchStart);
        e.preventDefault();
        e.stopImmediatePropagation();
        detected(EUDI.TOUCH);
    }
    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("touchstart", onTouchStart);
}
function initializeAndDetectUserDevicePageSize(detected) {
    function getSize() {
        for (const val of Object.keys(exports.CMaxWidthForPageSizeRange)) {
            if (window.innerWidth <= exports.CMaxWidthForPageSizeRange[val]) {
                detected(Number(val));
                break;
            }
        }
    }
    window.addEventListener("resize", getSize);
    getSize();
}
exports.DetectDeviceUtils = {
    initializeAndDetectUserDeviceInterface,
    initializeAndDetectUserDevicePageSize,
};
